// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRedoOutlinedSvg from "@fishx/icons-svg/es/asn/PRedoOutlined";
import FishxIcon from '../components/FishxIcon';

var PRedoOutlined = function PRedoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRedoOutlinedSvg
  }));
};

PRedoOutlined.displayName = 'PRedoOutlined';
export default React.forwardRef(PRedoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRedoOutlined.js
// module id = 3583
// module chunks = 0